import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';

export default function ImportPage() {
  return (
    <>
      <SEO
        title="Import | Fastlane ApS"
        description="Modtager Betaler (Freight Collect) og Forudbetalt Fragt (Freight Prepaid). Vi håndterer importspedition, B/L godkendelse, fortoldning og levering i hele Danmark."
        canonicalUrl="https://fastlane.dk/import"
      />

      <PageHeader
        title="Import"
        subtitle="Freight Collect og Freight Prepaid – sikker rådgivning og komplet spedition fra afsender til modtager."
        breadcrumbs={[
          { label: 'Ydelser', path: '/godstransport-i-europa' },
          { label: 'Import' }
        ]}
      />

      <div className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          {/* Modtager Betaler (Freight Collect) */}
          <section className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#0f2b48]">
              Modtager Betaler (Freight Collect)
            </h2>
            <p>
              Modtager arrangerer fragten, der typisk betales ved modtagelse af varerne. et kunne være en sending efter handelsklausulen FOB (Frit ombord) Ningbo - ref. Incoterms.
            </p>
            <p>
              Vi tilbyder via vort netværk at være speditør på opgaven. Vores agent kontakter afsender og samarbejde med afsender omkring opgaven. Normalt er vi herefter i stand til at estimere og oplyse en forventet ankomsttid.
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700 pt-2">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Basis proforma/kommerciel faktura, pakkeliste, leveringsbetingelser ref. Incoterms finder vi den optimale løsning og bestiller fragten.</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Vi hjælper med godkendelse af B/L (Bill og Lading)</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Vi vejleder omkring fragtforsikring og tegner gerne en sådan såfremt det måtte ønskes</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Sporing (tracking) under transit</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Fortoldning – koordinering med Skat</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Havnemyndigheder – koordinering omkring gebyrer og THC (Terminal Handling Cost)</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Levering i Danmark til dør på den ønskede adresse – koordinering med vognmand</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Lager – evt. modtagelse på vort lager med arbejdsindhold som aftalt</span>
              </li>
            </ul>
          </section>

          {/* Forudbetalt Fragt (Feight Prepaid) */}
          <section className="space-y-4 text-slate-700 leading-relaxed text-base sm:text-lg border-t border-slate-200 pt-10">
            <h2 className="text-2xl sm:text-3xl font-bold text-[#0f2b48]">
              Forudbetalt Fragt (Feight Prepaid)
            </h2>
            <p>
              Fragten frem til dansk eller europæisk havn / lufthavn arrangeres af afsender. I denne form betales fragten ofte sammen med varerne. Det kunne være en sending efter handelsklausulen CIF (Omkostninger, forsikring og fragt) København - ref. Incoterms.
            </p>
            <p className="font-semibold text-slate-900">
              Vi tilbyder, at være modtagerspeditør på disse forsendelser:
            </p>

            <ul className="space-y-2.5 text-sm sm:text-base text-slate-700 pt-1">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Koordinering med rederi/linieagent, luftfragtsspeditør (på baggrund af modtagelse af kopi af handelsfaktura, pakkeliste og B/L el. AWB)</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Fortoldning – koordinering med Skat</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Havnemyndigheder – koordinering omkring gebyrer og THC (Terminal Handling Cost)</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Levering i Danmark til dør på den ønskede adresse – koordinering med vognmand</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-check text-sky-600 mt-1 shrink-0" aria-hidden="true" />
                <span>Lager – evt. modtagelse på vort lager med arbejdsindhold som aftalt</span>
              </li>
            </ul>

            <div className="bg-amber-50/70 p-6 sm:p-8 rounded-2xl border border-amber-200 mt-6 space-y-3">
              <h3 className="text-base font-bold text-amber-950 uppercase tracking-wider">
                Køber du forudbetalt fragt skal du være opmærksom på en række risici, specielt ved forsendelse som stykgods:
              </h3>
              <ul className="space-y-2 text-sm text-slate-800">
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>Ofte betaler afsender i lande som Kina og Indien en kunstig lav fragt og får muligvis "kommission". Fragten bliver således betalt skjult i uvirkeligt høje udleveringsomkostninger så det ser billigt ud i udgangspunktet – ref. ”Fragtfælden” søg evt. på nettet der findes en del artikler herom.</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>Transittiden kan blive længere end nødvendigt</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>Muligheden for at følge forsendelsen er begrænset</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>Vareforsikring kan være mangelfuld eller ikke eksisterende</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="fa-solid fa-triangle-exclamation text-amber-600 mt-1 shrink-0" aria-hidden="true" />
                  <span>Godset sendes muligvis kun til Hamburg el. Göteborg med ekstra omkostninger til følge</span>
                </li>
              </ul>
            </div>

            <p className="pt-4 text-sm text-slate-700">
              Link til ofte stillede <Link to="/spoergsmaal-svar-fragt" className="text-sky-700 font-semibold underline">spørgsmål</Link>.
            </p>

            <p className="text-sm text-slate-700">
              Ønsker du en containerrate på det du skal have fragtet eller en generel afklaring, så er du velkommen til at sende os en mail på{' '}
              <a href="mailto:booking@fastlane.dk" className="text-sky-700 font-semibold underline">booking@fastlane.dk</a> eller ringe til os på{' '}
              <a href="tel:+4576121230" className="text-slate-900 font-semibold whitespace-nowrap">+45 76 12 12 30</a>. Du kan også sende os en{' '}
              <Link to="/fragtrater" className="text-sky-700 font-semibold underline">forespørgsel</Link>.
            </p>
          </section>
        </div>
      </div>
    </>
  );
}
